import { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DataContext } from "../../context/Data.context";
import { Separator } from "@moreirapontocom/npmhelpers";

const Welcome = () => {
  const navigate: any = useNavigate();
  const { data, setData } = useContext(DataContext);

  useEffect(() => {
    setData({
      ...data,
      pageHeader: {
        title: "Welcome",
        backButton: false,
      },
    });

    _checkProfiles();
  }, []);

  const _checkProfiles = () => {
    const storageKey = "profiles";
    const profilesStorage: any = localStorage.getItem(storageKey);
    if (profilesStorage) {
      const profiles: any = JSON.parse(profilesStorage);
      navigate(profiles.length > 0 ? "/home" : "/createProfile");
      return;
    }
  };

  return <>
    <div className="row text-center justify-content-center">
      <div className="col-6">
        <img src="/images/reader-white-light.png" alt="Metrix Reader" className="img-fluid" />
      </div>
    </div>

    <Separator size={20} />

    <div className="row justify-content-center">
      <div className="col-11">
        <h3>
          Welcome to the Metrix Reader App, since this is your first time running the App, we will walk you through setting up your profile and Reader.
        </h3>
      </div>
    </div>

    <Separator size={20} />

    <div className="d-grid">
      <Link
        to="/createProfile"
        className="btn btn-primary btn-featured">
        Begin
      </Link>
    </div>
  </>
};

export default Welcome;